<template>
  <qx-card title="列表">
    <EditDialog ref="editDialog" @sub="getData" />
    <FileDialog ref="fileDialog" />
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl='cmSalaryInfoNewBO.ajax?cmd=doQuerySalaryComplain'
          :params="fullSearchData"
          bizName="司机申诉数据导出"
          :excelKeys="newExcelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            >
              <section  slot-scope="scope">
                <section v-if="scope.column.property === 'carDriverName'" @click="toDriverDetail(scope.row)">
                  <span class="primary cur">{{scope.row[scope.column.property]}}</span>
                </section>
                <section v-else-if="scope.column.property === 'ordersCount'" @click="toDetail(scope.row)">
                  <span class="primary cur">{{scope.row[scope.column.property]}}</span>
                </section>
                <section v-else-if="scope.column.property === 'complainImg'" @click="toShowImg(scope.row)">
                  <span class="primary cur">{{scope.row[scope.column.property].length > 0 ? "查看" : ""}}</span>
                </section>
                <section v-else>{{scope.row[scope.column.property]}}</section>
              </section>
            </el-table-column>
            <el-table-column prop="control" label="操作" fixed="right" width="120">
            <template slot-scope="scope" v-if="scope.row.state === 0">
              <section>
                <qx-permpisions permpisions="6000914">
                  <span class="primary cur" @click="showEditDialiog(scope.row)">审核</span>
                </qx-permpisions>
                <!-- 操作按钮 end -->
              </section>
            </template>
          </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import EditDialog from './editDialog';
import FileDialog from './fileShowDialog';
import {
  driverSalaryComplaintList,
} from 'api/getPay';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
    EditDialog,
    FileDialog,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'createDate',
            label: '申诉时间',
          },
          {
            prop: 'ordersCount',
            label: '申诉订单',
          },
          // {
          //   prop: 'salaryComplainTypeName',
          //   label: '申诉类型',
          // },
          {
            prop: 'complainReason',
            label: '申诉原因',
          },
          {
            prop: 'complainImg',
            label: '照片',
          },
          {
            prop: 'userName',
            label: '申诉人',
          },
          {
            prop: 'stateName',
            label: '状态',
          },
          {
            prop: 'opName',
            label: '审核人',
          },
          {
            prop: 'opPhone',
            label: '审核人手机',
          },
          {
            prop: 'opReason',
            label: '审核备注',
          },
          {
            prop: 'opDate',
            label: '审核时间',
          },
        ],
        data: [ // 表格内容
        ],
      },
      newExcelKeys: null,
    };
  },
  methods: {
    getList: driverSalaryComplaintList,
    showEditDialiog (item) { // 审核
      this.$refs.editDialog.show(item);
    },
    toDetail (item) {
      this.jump({
        label: '工资详情',
        url: `/manage/getPay/writeOff/driver/detail?id=${item.sId}&settleMonth=${this.searchBoxData.settleMonth}&orderId=${item.orderIds}`,
        full: true,
      });
    },
    toShowImg (item) {
      this.$refs.fileDialog.show(item.complainImg);
    },
  },
  mounted () {
    this.newExcelKeys = this.excelKeys.replace('ordersCount', 'orderIds');
  },
};
</script>

<style lang="scss" scoped>
.introBtn{
  margin-left: 16px;
}
.control {
  span {
    margin-right: 8px;
  }
}
</style>
